module.exports = __webpack_public_path__ + "assets/default.6f9b1104.svg";